import { AuthService } from '../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { UserProfile, User, PerfilHackathon } from '../../../models/user.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  avaliacoes = false;
  mentories = false;
  equipes = false;

  loading = true;

  userProfile: UserProfile;

  constructor(public helper: HelpersService, private auth: AuthService) { }

  ngOnInit(): void {
    this.auth.getUser.then((user: User) => {
      this.userProfile = user.user;
      if (user.perfis.length > 0) {
        const perfilhackathon = user.perfis.find(perfil => perfil.hackathonId === this.helper.hackathonId);
        this.setPerfil(perfilhackathon);
      }
      this.loading = false;
    });
  }

  private setPerfil(perfil: PerfilHackathon) {
    if (perfil.perfil === 1) {
      this.mentories = true;
      this.equipes = true;
    }

    if (perfil.perfil === 2) {
      this.mentories = true;
    }

    if (perfil.perfil === 3) {
      this.avaliacoes = true;
    }
  }

  bloquearMentoria(): boolean {
    let dataLimiteFunctions = new Date('03-01-2021');
    let dataNow = new Date();
    if (dataNow > dataLimiteFunctions){
      // bloqueia as mentorias.
      return false;
    }

    // Mantem liberada as mentorias.
    return true;
  }

  signOut() {
    this.auth.signOut();
  }

  get userImg() {
    return this.userProfile.photoURL;
  }

  get userName() {
    return this.userProfile.displayName;
  }

}
